<template>
  <div>
    <template v-if="template === 'edit' || typeof template === 'undefined'">
        <label :class="labelClass ? labelClass : 'u-label'">
          {{ field.label + (field.required ? '* ' : '') }}
        </label>
        <input
          v-if        = "!field.readonly" type="date"
          placeholder = "MM/DD/YYYY"
          pattern     = "[0-9]{2}/[0-9]{2}/[0-9]{4}"
          ref         = "input"
          :class      = "'o-date qa-' + field.name + '__input'"
          :name       = "field.name"
          :value      = "fieldValue" @input="update($event.target.value)"
        />
        <input
          v-if        = "field.readonly" type="date"
          placeholder = "MM/DD/YYYY"
          pattern     = "[0-9]{2}/[0-9]{2}/[0-9]{4}"
          ref         = "input"
          readonly    = "readonly"
          disabled    = "disabled"
          :class      = "'o-date qa-' + field.name + '__input'"
          :name       = "field.name"
          :value      = "fieldValue"
        />
     </template>
    <template v-if="template === 'detail'">
        <label :class="labelClass ? labelClass : 'u-label'">
          {{ field.label + (field.required ? '* ' : '') }}
        </label>
        <p
          class  = "u-paragraph"
          :class = "'qa-' + field.name + '__value'"
        >
          {{ value }}
        </p>
     </template>
  </div>
</template>


<script>
export default {
  props: ['field', 'value', 'labelClass', 'template'],
  data () {
    return {
      fieldValue: ''
    }
  },
  watch: {
    value () {
      this.calculateValue()
    }
  },
  mounted () {
    // set the date which will be displayed in the field as soon as the input field is rendered and we know
    // if its a date or text field
    this.calculateValue()
  },
  methods: {
    calculateValue () {
      if (this.template !== 'edit') {
        return
      }
      let fieldType = this.$refs.input.type
      // only convert to yyyy-mm-dd format if the field type is date and not text (as is the case on IE11)
      if (/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(this.value) &&
        typeof fieldType !== 'undefined' && fieldType === 'date') {
        let dateParts = this.value.split('/')
        let month = dateParts[0]
        let day = dateParts[1]
        let year = dateParts[2]
        this.fieldValue = [year, month, day].join('-')
      } else {
        this.fieldValue = this.value
      }
    },
    update (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldDate.vue?5ba20901